import { BoxProps } from '@jfs/ui-new'
import { Dimensions, ImageStyle, ViewStyle } from 'react-native'
import { Colors } from '../../util/util'

const { width } = Dimensions.get('screen')
const defaultStyles = {
  container: { alignItems: 'center', flex: 1, backgroundColor: 'WHITE' } as BoxProps,
  flatListStyle: { flexGrow: 0, backgroundColor: 'white' } as ViewStyle,
  carouselDots: (selected: boolean) =>
    ({
      height: 8,
      width: 8,
      backgroundColor: selected ? Colors.PRIMARY_GREY : Colors.BORDER_COLOR,
      margin: 8,
      borderRadius: 4,
    } as ViewStyle),
  itemContainer: () => ({} as ViewStyle),
  imageStyle: {} as ImageStyle,
  dotContainer: {
    width: 140,
    alignItems: 'center',
  } as ViewStyle,
  closeBtn: {
    position: 'absolute',
    top: 70,
    right: 10,
    zIndex: 2,
  } as ViewStyle,
  underlayColor: () => Colors.TRANSPARENT,
}

const courselTheme = {
  CAROUSAL_IMAGE_FULL_HEIGHT: 147,
  CAROUSAL_IMAGE_FULL_HEIGHT_VERTICAL: 185,
  CAROUSAL_VIEW_FULL_HEIGHT: 160,
  CAROUSAL_FULL_MARGIN: 16,
  CAROUSAL_BORDER_RADIUS: 10,
}

export const fullScreenStyles = {
  width,
  // height,
  zIndex: 20,
  left: 0,
  right: 0,
  top: 0,
  bottom: 0,
  position: 'absolute',
  justifyContent: 'center',
  alignItems: 'center',
} as ViewStyle

const styles = {
  ...defaultStyles,
  imageStyle: (isLarge: boolean | undefined, isFromProfile: boolean | undefined) =>
    ({
      width: isLarge ? 350 : isFromProfile ? width - 32 : width / 1.35,
      justifyContent: 'center',
      alignItems: 'center',
      height: !isFromProfile
        ? courselTheme.CAROUSAL_IMAGE_FULL_HEIGHT
        : courselTheme.CAROUSAL_IMAGE_FULL_HEIGHT_VERTICAL,
    } as ImageStyle),
  curvedImageStyle: {
    borderRadius: courselTheme.CAROUSAL_BORDER_RADIUS,
  } as ImageStyle,
  playContainer: {
    height: 30,
    width: 30,
    borderRadius: 20,
    // backgroundColor: 'BLACK_75',
    // opacity: 0.8,
    justifyContent: 'center',
    alignItems: 'center',
  } as BoxProps,
  listContainerStyle: { flexGrow: 0, alignSelf: 'center', paddingBottom: 16, paddingRight: 25 } as ViewStyle,
  itemContainer: (isLarge: boolean | undefined, isFromProfile: boolean | undefined) =>
    ({
      backgroundColor: 'TRANSPARENT',
      paddingLeft: 25,
      paddingTop: isFromProfile ? 25 : 20,
      width: isLarge ? 350 : undefined,
      // marginRight: courselTheme.CAROUSAL_FULL_MARGIN,
    } as BoxProps),
}

export default styles
